import { Box, Text } from '@chakra-ui/react';

type Props = {
  error?: string;
  touched?: boolean;
};

export default function ErrorContainer({ error, touched = false }: Readonly<Props>) {
  if (!error || !touched) {
    return null;
  }

  return (
    <Box backgroundColor="red100" width="100%" padding={2} flexShrink={0}>
      <Text color="red" textStyle="md">
        {error}
      </Text>
    </Box>
  );
}
